import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import get from "lodash/get";
import React from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { instance } from "../../../../../Actions/AxiosInstance";
import { GetFeature } from "../../../../../Actions/commonAction";
import deleteIcon from "../../../../../Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import cancelIcon from "../../../../../Assets/Svg/cancel_black.svg";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { convertDateForBackend, getFormattedDate } from "../../../../../Utils";
import "./index.css";
import { sortArrByDate } from "../../../../../Utils/arr";

export default class Ledger extends React.Component {
  state = {
    datarecieved: false,
    masterprofileid: null,
  };

  componentWillMount() {
    this.LoadLedger();
    const masterprofileid = get(
      this.props,
      "AuthenticationAction.login.masterprofileid",
      "",
    );
    this.setState({ masterprofileid });
  }

  LoadLedger = () => {
    const {
      leaveoption,
      getEmpId,
      leavecycleduration,
      todayLeaveDate,
      SelectedMonth,
    } = this.props;
    this.setState({
      leavepolicyid: leaveoption.leavepolicyid,
      leaveid: leaveoption.leaveid,
      leavetypeid: leaveoption.leavetypeid,
      leavecategoryid: leaveoption.leavecategoryid,
    });

    let fromdate = null;
    let todate = null;

    if (leavecycleduration) {
      const { leavecyclestartdate } = this.props.leaveCycleList.find(
        (lc) =>
          lc.leavecyclestartdate <=
            moment(todayLeaveDate).format("YYYY-MM-DD") &&
          moment(todayLeaveDate).format("YYYY-MM-DD") <= lc.leavecycleenddate,
      );

      fromdate = leavecyclestartdate;
      todate = moment(todayLeaveDate).endOf("month").format("YYYY-MM-DD");

      this.setState({ fromdate, todate });
    }

    const data = {
      // employeeid: null,
      employeeid: getEmpId(),
      leaveid: leaveoption.leaveid,
      leavetypeid: leaveoption.leavetypeid,
      fromdate,
      todate,
      leavecycledurationid: leaveoption.leavecycledurationid,
    };
    if (get(this.props, "SelectedEmpData.displayvalue", "")) {
      data.employeeid = get(this.props, "SelectedEmpData.displayvalue", "");
    }
    instance
      .post("leaves/leaveledger", data)
      .then((result) => {
        if (result.data.result.rows[0]) {
          const DATA = result.data.result.rows[0];
          const res = {};
          Object.keys(DATA).forEach((key) => {
            res[key] =
              DATA[key] === 0
                ? "0"
                : DATA[key] === null
                ? []
                : DATA[key] || "-";
          });
          this.setState({ ...res, datarecieved: true });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  HandleKeyDown(name, e) {
    if (
      [69, 187, 188, 189, 190, 107, 109, 110, 43, 45, 46].includes(e.keyCode)
    ) {
      e.preventDefault();
    }
    this.setState({ [name]: e.target.value });
  }

  UpdateComment(txt) {
    this.setState({ comment: txt.target.value });
  }

  handleEmplistExpandClick = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  handleEmplistExpandClick01 = () => {
    this.setState((state) => ({ expandDebit: !state.expandDebit }));
  };

  showAdditionalCredit = () => {
    this.setState((state) => ({
      showAdditionalCredit: !state.showAdditionalCredit,
    }));
  };

  showWeekOff = () => {
    this.setState((state) => ({ showWeekOff: !state.showWeekOff }));
  };

  showAdditionalDebit = () => {
    this.setState((state) => ({
      showAdditionalDebit: !state.showAdditionalDebit,
    }));
  };

  giftCreditLeave = () => {
    this.setState((state) => ({ giftCreditLeave: !state.giftCreditLeave }));
  };

  creditedThisYear = () => {
    this.setState((state) => ({ creditedThisYear: !state.creditedThisYear }));
  };

  leaveApprovedUsed = () => {
    this.setState((state) => ({ leaveApprovedUsed: !state.leaveApprovedUsed }));
  };

  showDebitGifted = () => {
    this.setState((state) => ({ showDebitGifted: !state.showDebitGifted }));
  };

  extratimeLeave = () => {
    this.setState((state) => ({ extratimeLeave: !state.extratimeLeave }));
  };

  compOffLeave = () => {
    this.setState((state) => ({ compOffLeave: !state.compOffLeave }));
  };

  policyDeduction = () => {
    this.setState((state) => ({ policyDeduction: !state.policyDeduction }));
  };

  leavePendingApproval = () => {
    this.setState((state) => ({
      leavePendingApproval: !state.leavePendingApproval,
    }));
  };

  lapsedLeaves = () => {
    this.setState((state) => ({
      lapsedLeaves: !state.lapsedLeaves,
    }));
  };

  leaveApprovedUnused = () => {
    this.setState((state) => ({
      leaveApprovedUnused: !state.leaveApprovedUnused,
    }));
  };

  carriedForward = () => {
    this.setState((state) => ({ carriedForward: !state.carriedForward }));
  };

  usedCompOffLeaves = () => {
    this.setState((state) => ({
      usedCompOffLeaves: !state.usedCompOffLeaves,
    }));
  };

  compOffCreditDetails = (creditedDate) => {
    this.setState((state) => ({
      clickedDate: state.clickedDate === creditedDate ? null : creditedDate,
    }));
  };

  handleLeaveAdjustment(type) {
    let leavecount;
    let comment;
    type == "credit"
      ? (leavecount = this.state.creditLeavesCount)
      : (leavecount = -Math.abs(this.state.debitLeavesCount));
    type == "credit"
      ? (comment = this.state.creditComment)
      : (comment = this.state.debitComment);
    if (leavecount == 0) {
      this.props.enqueueSnackbar(`please add leave ${type} count`, {
        variant: "error",
      });
    }
    const data = {
      leavepolicyid: this.state.leavepolicyid,
      leaveid: this.state.leaveid,
      leavetypeid: this.state.leavetypeid,
      leavecategoryid: this.state.leavecategoryid,
      leavecount,
      comment,
      monthid: new Date().getMonth() + 1,
      adjustmentdate: convertDateForBackend(new Date()),
    };
    if (get(this.props, "SelectedEmpData.displayvalue", "")) {
      data.employeeid = get(this.props, "SelectedEmpData.displayvalue", "");
    }
    instance
      .post("leaves/insertupdateempleaveadjustment", data)
      .then(() => {
        if (type == "credit") this.handleEmplistExpandClick();
        if (type == "debit") this.handleEmplistExpandClick01();
        this.LoadLedger();
        this.props.enqueueSnackbar(`Leave ${type} request applied succefully`, {
          variant: "success",
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  deleteAdjustedLeaves(id) {
    this.props.enqueueSnackbar(
      `Are you sure you want to delete additional leave?`,
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              instance
                .delete(`leaves/deleteadjustedleaves/${id}`)
                .then(() => {
                  this.LoadLedger();
                  this.props.closeSnackbar();
                  this.props.enqueueSnackbar("deleted successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  render() {
    const { leaveoption } = this.props;
    return (
      <div>
        <div className="leavebalancehead" style={{ height: 25 }}>
          <span className="floatleft margin-left-14 margin-top-8 t-bold">
            <div className="floatleft">
              <span
                className="drawer-close-btn"
                onClick={() => this.props.toggleDrawer("right", false)}
              >
                <img src={cancelIcon}></img>
              </span>
            </div>

            <span className="floatleft margin-left-16 margin-top-8">
              {this.props.selectedLeave.leavename} Ledger {`<>`}{" "}
              {getFormattedDate(this.state.fromdate)} to{" "}
              {getFormattedDate(this.state.todate)}
            </span>
          </span>
          <span className="floatright margin-right-16">
            {this.state.annualleave ? (
              <div className="annual-total-leaves">
                <span className="t-bold t-16">
                  <FormattedMessage
                    id="LbAnnualLeave"
                    defaultMessage="Annual Leave"
                  />
                  : &nbsp;
                  {!get(this.state, "annualleave", "") ? (
                    <span>0</span>
                  ) : (
                    <span>
                      <React.Fragment>
                        {get(this.state, "leavetypeid", "") == 3
                          ? `${Math.floor(
                              get(this.state, "annualleave", "") / 60,
                            )} Hrs ${Math.floor(
                              get(this.state, "annualleave", "") % 60,
                            )} Mins`
                          : // : `${Math.floor(get(this.state, "annualleave", ""))} Days`}
                            `${get(this.state, "annualleave", "")} Days`}
                      </React.Fragment>
                    </span>
                  )}
                </span>
              </div>
            ) : (
              ""
            )}
            {this.state.totalavailablebal && this.state.leavetypeid != 99 ? (
              <div className="annual-total-balance">
                <span className="t-bold t-16">
                  <FormattedMessage
                    id="LbTotalavailablebalance"
                    defaultMessage="Total available balance"
                  />
                  : &nbsp;
                  {!get(this.state, "totalavailablebal", "") ? (
                    <span className="t-16">0</span>
                  ) : (
                    <span className="t-16">
                      <React.Fragment>
                        {this.state.leavetypeid == 3
                          ? `${parseInt(
                              Math.floor(
                                get(this.state, "totalavailablebal", 1) / 60,
                              ),
                            )} Hrs ${Math.floor(
                              get(this.state, "totalavailablebal", 1) % 60,
                            )} Mins`
                          : get(this.state, "totalavailablebal", 1)}
                      </React.Fragment>
                    </span>
                  )}
                </span>
              </div>
            ) : (
              ""
            )}
          </span>
        </div>
        {this.state.datarecieved && (
          <Grid container>
            <Grid item xs={12} md={6} sm={12} className="padding16">
              <div
                style={{
                  border: "1px solid #ddd",
                  maxHeight: "80vh",
                  overflowY: "auto",
                }}
              >
                {GetFeature("leaveLedger") &&
                GetFeature("leaveLedger").permissions.editable ? (
                  <div className="annual-creditleave">
                    <span className="floatleft padding-top-8 t-bold">
                      <FormattedMessage
                        id="LbLeaveCredit"
                        defaultMessage="Leave Credit"
                      />
                    </span>
                    <span className="floatright">
                      <Button
                        className={
                          !this.state.creditbutton ||
                          this.state.creditbutton == "-" ||
                          leaveoption.active == 0
                            ? "btn btn-primary-sm-grey"
                            : "btn btn-primary-sm-blue"
                        }
                        onClick={this.handleEmplistExpandClick}
                        disabled={
                          leaveoption.active == 0
                            ? true
                            : leaveoption.leavetypeid == 99 ||
                              leaveoption.leavetypeid == 100
                            ? leaveoption.displaycount == "0 Days"
                              ? true
                              : false
                            : false
                        }
                        aria-label="Show more"
                        variant="contained"
                      >
                        Credit Now
                      </Button>
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <Collapse
                  in={this.state.expanded}
                  timeout="auto"
                  unmountOnExit
                  className="padding20 padding-bottom-10"
                >
                  <Paper className="leave-creadit-expand padding16">
                    <div>
                      <span className="margin-right-15">
                        <FormattedMessage
                          id="LbCredit"
                          defaultMessage="Credit"
                        />
                      </span>
                      <span className="margin-right-15">
                        <input
                          type="number"
                          className="weekoff-number"
                          min="00"
                          max="365"
                          placeholder="credit leave count"
                          value={this.state.creditLeavesCount}
                          onChange={this.HandleKeyDown.bind(
                            this,
                            "creditLeavesCount",
                          )}
                        />
                      </span>
                      <span>
                        {this.state.leavetypeid == 3 ? "Hours" : "Leaves"}
                      </span>
                    </div>
                    <div className="margin-top-10">
                      <p className="input-label">Add comment</p>
                      <TextArea
                        className="width100"
                        placeholder="Add comment"
                        variant="outlined"
                        multiline
                        value={this.state.creditComment}
                        onChange={this.HandleKeyDown.bind(
                          this,
                          "creditComment",
                        )}
                      />
                    </div>
                    <div className="margin-top-8">
                      <span>
                        <Button
                          variant="contained"
                          size="samll"
                          color="primary"
                          onClick={this.handleLeaveAdjustment.bind(
                            this,
                            "credit",
                          )}
                          className="btn btn-primary-sm-blue"
                        >
                          <FormattedMessage
                            id="LbCredit"
                            defaultMessage="Credit"
                          />
                        </Button>
                      </span>
                    </div>
                  </Paper>
                </Collapse>
                {get(this.state, "leavetypeid", "") == 4 ? (
                  <div className="leave-data">
                    <div className="display-table width100 height100">
                      <div className="display-table-cell vertical-middle text-center">
                        <h3 className="headline-h3">
                          Unpaid leaves do not get credited
                        </h3>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="leave-data">
                    {this.state.leavecredited ? (
                      <div
                        className={
                          this.state.leavecredited == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={
                          this.state.leavecredited && this.creditedThisYear
                        }
                      >
                        <span>
                          <FormattedMessage
                            id="LbEarnedthisyear"
                            defaultMessage="Earned This Year"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.leavecredited == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.leavetypeid == 3
                                  ? `${parseInt(
                                      this.state.leavecredited / 60,
                                    )} Hrs ${
                                      this.state.leavecredited % 60
                                    } Mins`
                                  : this.state.leavecredited}
                              </React.Fragment>
                              {this.state.creditedThisYear ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )}
                            </span>
                          )}
                        </span>
                        {this.state.creditedThisYear ? (
                          <div className="padding-top-6">
                            {!this.state.creditedleaves ? (
                              <span className="">0</span>
                            ) : (
                              <React.Fragment>
                                {sortArrByDate({
                                  arr: this.state.creditedleaves,
                                  datekey: "crediteddate",
                                }).map((option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={8} sm={8}>
                                      <p className="data-value">
                                        {getFormattedDate(option.crediteddate)}
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={4}
                                      sm={4}
                                      className="text-align-right"
                                    >
                                      <p className="data-count">
                                        {option.crediteddata}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ))}
                              </React.Fragment>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.extratime ? (
                      <div
                        className={
                          this.state.extratime == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={this.state.extratime && this.extratimeLeave}
                      >
                        <span>
                          <FormattedMessage
                            id="LbExtratime"
                            defaultMessage="Extra Time"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.extratime == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.extratime / 60}:
                                {this.state.extratime % 60} Hrs
                              </React.Fragment>
                            </span>
                          )}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.leavecarryforward ? (
                      <div
                        className={
                          this.state.leavecarryforward == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={
                          this.state.leavecarryforward && this.carriedForward
                        }
                      >
                        <span>
                          <FormattedMessage
                            id="LbCarriedforward"
                            defaultMessage="Carried forward"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.leavecarryforward == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.leavetypeid == 3
                                  ? `${this.state.leavecarryforward / 60}:${
                                      this.state.leavecarryforward % 60
                                    } Hrs`
                                  : this.state.leavecarryforward}
                              </React.Fragment>
                              {this.state.carriedForward ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )}
                            </span>
                          )}
                        </span>
                        {this.state.carriedForward ? (
                          <div>
                            {!this.state.carryforwardtleaves ? (
                              <span>0</span>
                            ) : (
                              <React.Fragment>
                                {this.state.carryforwardtleaves.map(
                                  (option) => (
                                    <Grid key="key" container>
                                      <Grid item xs={12} md={3} sm={4}>
                                        <p className="data-value">
                                          {getFormattedDate(
                                            option.crediteddate,
                                          )}
                                        </p>
                                      </Grid>
                                      <Grid item xs={12} md={7} sm={4}>
                                        <span>{option.comment}</span>
                                      </Grid>
                                      <Grid item xs={12} md={2} sm={4}>
                                        <p className="data-count">
                                          {option.crediteddata}
                                        </p>
                                      </Grid>
                                    </Grid>
                                  ),
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.giftcredited ? (
                      <div
                        className={
                          this.state.giftcredited == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={
                          this.state.giftcredited && this.giftCreditLeave
                        }
                      >
                        <span>
                          <FormattedMessage
                            id="LbGiftcredited"
                            defaultMessage="Gift Credited"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.giftcredited == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span
                              className="default-count"
                              style={{ right: 32 }}
                            >
                              <React.Fragment>
                                {this.state.giftcredited}
                              </React.Fragment>
                              {/* {this.state.giftCreditLeave ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )} */}
                            </span>
                          )}
                        </span>
                        {this.state.giftCreditLeave ? (
                          <div>
                            {!this.state.giftcreditedleaves ? (
                              <span className="">0</span>
                            ) : (
                              <React.Fragment>
                                {this.state.giftcreditedleaves.map((option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={3} sm={4}>
                                      <p className="data-value">
                                        {getFormattedDate(option.crediteddate)}
                                      </p>
                                    </Grid>
                                    <Grid item xs={12} md={7} sm={4}>
                                      <span>{option.comment}</span>
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={4}>
                                      <p className="data-count">
                                        {option.crediteddata}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ))}
                              </React.Fragment>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.creditedcompoff ? (
                      <div
                        className={
                          this.state.creditedcompoff == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={this.state.creditedcompoff && this.compOffLeave}
                      >
                        <span>
                        <FormattedMessage
                            id="LbCreditedCompOff"
                            defaultMessage="Credited Comp Off"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.creditedcompoff == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.creditedcompoff}
                                
                              </React.Fragment>
                              {this.state.compOffLeave ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )}
                            </span>
                          )}
                        </span>
                        {this.state.compOffLeave ? (
                          <div>
                            {!this.state.creditedleaves ? (
                              <span className="">0</span>
                            ) : (
                              <div>
                                <div>
                                  <React.Fragment>
                                    {sortArrByDate({
                                      arr: this.state.creditedleaves,
                                      datekey: "crediteddate",
                                    }).map((option) => (
                                      <div>
                                        <Grid key="key" container onClick={(e) => e.stopPropagation(e)}>
                                          <Grid item xs={12} md={8} sm={8}>
                                            <p className="data-value" onClick={() => this.compOffCreditDetails(option.crediteddate)}>
                                              {getFormattedDate(
                                                option.crediteddate,
                                              )}
                                            </p>
                                          </Grid>
                                          <Grid item xs={12} md={4} sm={4}>
                                            <p className="data-count">
                                              {option.crediteddata}
                                            </p>
                                          </Grid>
                                        </Grid>
                                        {this.state.clickedDate === option.crediteddate && (
                                          <div className="leave-credit-type">
                                            <React.Fragment>
                                              {sortArrByDate({
                                                arr: option.creditedfor,
                                                datekey: "creditedfordate",
                                              }).map((credited) => (
                                                <Grid key="key" container onClick={(e) => e.stopPropagation(e)}>
                                                  <Grid item xs={12} md={8} sm={8}>
                                                    <p className="data-value">
                                                      {getFormattedDate(
                                                        credited.creditedfordate,
                                                      )}
                                                    </p>
                                                  </Grid>
                                                  <Grid item xs={12} md={4} sm={4}>
                                                    <p className="data-count">
                                                      {credited.hours}
                                                    </p>
                                                  </Grid>
                                                </Grid>
                                              ))}
                                            </React.Fragment>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                    
                                  </React.Fragment>
                                  
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                        
                      </div>
                    ) : (
                      ""
                    )}

                    {/* {this.state.creditedcompoff ? (
                      <div
                        className={
                          this.state.creditedcompoff == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                      >
                        <span>
                          <FormattedMessage
                            id="LbCreditedCompOff"
                            defaultMessage="Credited Comp Off"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.creditedcompoff == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.creditedcompoff}
                              </React.Fragment>
                            </span>
                          )}
                        </span>
                      </div>
                    ) : (
                      ""
                    )} */}

                    {this.state.weeklyoff ? (
                      <div
                        className={
                          this.state.weeklyoff == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={this.state.weeklyoff && this.showWeekOff}
                      >
                        <span>
                          <FormattedMessage
                            id="LbWeekOff"
                            defaultMessage="Week Off"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.weeklyoff == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.weeklyoff}
                              </React.Fragment>
                              {this.state.showWeekOff ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )}
                            </span>
                          )}
                        </span>
                        {this.state.showWeekOff ? (
                          <div>
                            {!this.state.weekoffleaves ? (
                              <span className="">0</span>
                            ) : (
                              <React.Fragment>
                                {this.state.weekoffleaves.map((option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={8} sm={8}>
                                      <p className="data-value">
                                        {getFormattedDate(option.crediteddate)}
                                      </p>
                                    </Grid>
                                    <Grid item xs={12} md={4} sm={4}>
                                      <p className="data-count">
                                        {option.crediteddata}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ))}
                              </React.Fragment>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.additionalcreditleaves ? (
                      <div
                        className={
                          this.state.additionalcredit == 0
                            ? "leave-credit-type-disabled"
                            : "leave-credit-type"
                        }
                        onClick={
                          this.state.additionalcredit &&
                          this.showAdditionalCredit
                        }
                      >
                        <span>
                          <FormattedMessage
                            id="LbAdditionalcredited"
                            defaultMessage="Additional Credited"
                          />
                        </span>
                        <span className="floatright">
                          {this.state.additionalcredit == 0 ? (
                            <span className="no-count">0</span>
                          ) : (
                            <span className="default-count">
                              <React.Fragment>
                                {this.state.leavetypeid == 3
                                  ? `${parseInt(
                                      this.state.additionalcredit / 60,
                                    )} Hrs ${
                                      this.state.additionalcredit % 60
                                    } Mins`
                                  : this.state.additionalcredit}
                              </React.Fragment>
                              {this.state.showAdditionalCredit ? (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_down
                                </i>
                              ) : (
                                <i className="material-icons muiicon expand-icon">
                                  keyboard_arrow_right
                                </i>
                              )}
                            </span>
                          )}
                        </span>
                        {this.state.showAdditionalCredit ? (
                          <div>
                            {!this.state.additionalcreditleaves ? (
                              <span className="">0</span>
                            ) : (
                              <React.Fragment>
                                {this.state.additionalcreditleaves.map(
                                  (option) => (
                                    <Grid
                                      className="margin-bottom-8"
                                      key="key"
                                      container
                                      style={{
                                        borderBottom: "1px dotted #ddd",
                                        paddingBottom: 8,
                                      }}
                                    >
                                      <Grid item xs={12} md={8} sm={8}>
                                        <p className="data-value">
                                          {getFormattedDate(
                                            option.crediteddate,
                                          )}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        sm={4}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          paddingRight: 12,
                                        }}
                                      >
                                        <p
                                          className="data-count"
                                          style={{
                                            float: "left",
                                            marginRight:
                                              this.state.masterprofileid == 9
                                                ? 4
                                                : 20,
                                          }}
                                        >
                                          {option.crediteddata}
                                        </p>
                                        {this.state.masterprofileid == 9 && (
                                          <img
                                            src={deleteIcon}
                                            onClick={this.deleteAdjustedLeaves.bind(
                                              this,
                                              option.empleaveadjustmentid,
                                            )}
                                            style={{
                                              float: "left",
                                              height: 16,
                                            }}
                                          ></img>
                                        )}
                                      </Grid>
                                      {option.comment ? (
                                        <Grid item xs={12} md={12} sm={4}>
                                          <p className="data-value">
                                            <strong>Message: </strong>
                                            {option.comment}
                                          </p>
                                        </Grid>
                                      ) : (
                                        ""
                                      )}
                                      {option.addedby ? (
                                        <Grid item xs={12} md={12} sm={4}>
                                          <p className="data-value">
                                            <strong>Credited by: </strong>
                                            {option.addedby}
                                          </p>
                                        </Grid>
                                      ) : (
                                        ""
                                      )}
                                    </Grid>
                                  ),
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
              {this.state.leavetypeid != 99 && (
                <div className="leave-total-credit">
                  <span className="margin-left-8">
                    <FormattedMessage
                      id="LbTotalcredit"
                      defaultMessage="Total Credit"
                    />
                  </span>
                  <span className="floatright">
                    {!this.state.totalcredit ? (
                      <span className="default-count">0</span>
                    ) : (
                      <span className="default-count">
                        <React.Fragment>
                          {this.state.leavetypeid == 3
                            ? `${parseInt(this.state.totalcredit / 60)} Hrs ${
                                this.state.totalcredit % 60
                              } Mins`
                            : this.state.totalcredit}
                        </React.Fragment>
                      </span>
                    )}
                  </span>
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={6} sm={12} className="padding16">
              <div
                style={{
                  border: "1px solid #ddd",
                  maxHeight: "80vh",
                  overflowY: "auto",
                }}
              >
                {GetFeature("leaveLedger") &&
                GetFeature("leaveLedger").permissions.editable ? (
                  <div className="annual-debitleave">
                    <span className="floatleft padding-top-8 t-bold">
                      <FormattedMessage
                        id="LbLeavedebit"
                        defaultMessage="Leave Debit"
                      />
                    </span>
                    <span>
                      <span className="floatright">
                        <Button
                          className={
                            !this.state.debitbutton ||
                            this.state.debitbutton == "-" ||
                            leaveoption.active == 0
                              ? "btn btn-primary-sm-grey"
                              : "btn btn-primary-sm-blue"
                          }
                          onClick={this.handleEmplistExpandClick01}
                          disabled={
                            leaveoption.active == 0
                              ? true
                              : leaveoption.leavetypeid == 99 ||
                                leaveoption.leavetypeid == 100
                              ? leaveoption.displaycount == "0 Days"
                                ? true
                                : false
                              : false
                          }
                          aria-label="Show more"
                        >
                          Debit Now
                        </Button>
                      </span>
                    </span>
                  </div>
                ) : null}
                <Collapse
                  in={this.state.expandDebit}
                  timeout="auto"
                  unmountOnExit
                  className="padding20 padding-bottom-10"
                >
                  <Paper className="leave-creadit-expand padding16">
                    <div>
                      <span className="margin-right-15">
                        <FormattedMessage id="LbDebit" defaultMessage="Debit" />
                      </span>
                      <span className="margin-right-15">
                        <input
                          type="number"
                          className="weekoff-number"
                          min="00"
                          max="365"
                          placeholder="Debit leave count"
                          value={this.state.debitLeavesCount}
                          onChange={this.HandleKeyDown.bind(
                            this,
                            "debitLeavesCount",
                          )}
                        />
                      </span>
                      <span>
                        {this.state.leavetypeid == 3 ? "Hours" : "Leaves"}
                      </span>
                    </div>
                    <div className="margin-top-10">
                      <p className="input-label">Add comment</p>
                      <TextArea
                        className="leave-creadit-textarea"
                        maxLength="550"
                        value={this.state.debitComment}
                        onChange={this.HandleKeyDown.bind(this, "debitComment")}
                        variant="outlined"
                        multiline
                        placeholder="Add comment"
                      />
                    </div>
                    <div className="margin-top-8">
                      <span>
                        <Button
                          variant="contained"
                          size="samll"
                          color="primary"
                          onClick={this.handleLeaveAdjustment.bind(
                            this,
                            "debit",
                          )}
                          className="btn btn-primary-sm-blue"
                        >
                          <FormattedMessage
                            id="LbDebit"
                            defaultMessage="Debit"
                          />
                        </Button>
                      </span>
                    </div>
                  </Paper>
                </Collapse>
                <div className="leave-data">
                  {this.state.leaveapproved_used ? (
                    <div
                      className={
                        this.state.leaveapproved_used == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={
                        this.state.leaveapproved_used && this.leaveApprovedUsed
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbLeaveapproved"
                          defaultMessage="Leave approved and used"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.leaveapproved_used == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.leavetypeid == 3
                                ? `${parseInt(
                                    this.state.leaveapproved_used / 60,
                                  )} Hrs ${
                                    this.state.leaveapproved_used % 60
                                  } Mins`
                                : this.state.leaveapproved_used}
                            </React.Fragment>
                            {this.state.leaveApprovedUsed ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.leaveApprovedUsed ? (
                        <div>
                          {!this.state.leaveapproved_usedleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.leaveapproved_usedleaves.map(
                                (option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={10} sm={4}>
                                      <span className="data-value">
                                        {getFormattedDate(option.fromdatetime)}
                                      </span>
                                      <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="data-value">
                                        {getFormattedDate(option.todattime)}
                                      </span>
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                      <p className="data-count">
                                        {option.totaldaycount}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ),
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.policydeductioncount ? (
                    <div
                      className={
                        this.state.policydeductioncount == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={
                        this.state.policydeductioncount && this.policyDeduction
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbPolicydeduction"
                          defaultMessage="Policy deduction"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.policydeductioncount == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.leavetypeid == 3
                                ? `${this.state.policydeductioncount / 60}:${
                                    this.state.policydeductioncount % 60
                                  } Hr`
                                : this.state.policydeductioncount}
                            </React.Fragment>
                            {this.state.policyDeduction ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.policyDeduction ? (
                        <div>
                          {!this.state.policydeductionleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.policydeductionleaves.map(
                                (option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={10} sm={4}>
                                      <span className="data-value">
                                        {getFormattedDate(option.fromdatetime)}
                                      </span>
                                      <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="data-value">
                                        {getFormattedDate(option.todatetime)}
                                      </span>
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                      <p className="data-count">
                                        {option.totaldaycount}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ),
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.leaveapproved_unused ? (
                    <div
                      className={
                        this.state.leaveapproved_unused == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={
                        this.state.leaveapproved_unused &&
                        this.leaveApprovedUnused
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbLeaveapprovedunused"
                          defaultMessage="Leave approved and unused"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.leaveapproved_unused == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span>
                            <React.Fragment>
                              {this.state.leavetypeid == 3 ? (
                                `${this.state.leaveapproved_unused / 60}:${
                                  this.state.leaveapproved_unused % 60
                                } Hr`
                              ) : (
                                <span className="default-count">
                                  {" "}
                                  {this.state.leaveapproved_unused}
                                </span>
                              )}
                            </React.Fragment>
                            {this.state.leaveApprovedUnused ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.leaveApprovedUnused ? (
                        <div>
                          {!this.state.leaveapproved_unusedleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.leaveapproved_unusedleaves.map(
                                (option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={10} sm={4}>
                                      <span className="data-value">
                                        {getFormattedDate(option.fromdatetime)}
                                      </span>
                                      <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="data-value">
                                        {getFormattedDate(option.todatetime)}
                                      </span>
                                    </Grid>

                                    <Grid item xs={12} md={2} sm={2}>
                                      <p className="data-count">
                                        {option.totaldaycount}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ),
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.leaveapproval_pending ? (
                    <div
                      className={
                        this.state.leaveapproval_pending == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={
                        this.state.leaveapproval_pending &&
                        this.leavePendingApproval
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbLeavependingapproval"
                          defaultMessage="Leave pending approval"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.leaveapproval_pending == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.leavetypeid == 3
                                ? `${parseInt(
                                    this.state.leaveapproval_pending / 60,
                                  )} Hrs ${
                                    this.state.leaveapproval_pending % 60
                                  } Mins`
                                : this.state.leaveapproval_pending}
                            </React.Fragment>
                            {this.state.leavePendingApproval ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.leavePendingApproval ? (
                        <div>
                          {!this.state.leaveapproval_pendingleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.leaveapproval_pendingleaves.map(
                                (option) => (
                                  <Grid key="key" container>
                                    <Grid item xs={12} md={10} sm={4}>
                                      <span className="data-value">
                                        {getFormattedDate(option.fromdatetime)}
                                      </span>
                                      <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="data-value">
                                        {getFormattedDate(option.todatetime)}
                                      </span>
                                    </Grid>

                                    <Grid item xs={12} md={2} sm={2}>
                                      <p className="data-count">
                                        {option.totaldaycount}
                                      </p>
                                    </Grid>
                                  </Grid>
                                ),
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.lapsedcount ? (
                    // <div
                    //   className={
                    //     this.state.lapsedcount == 0
                    //       ? "leave-credit-type-disabled"
                    //       : "leave-credit-type"
                    //   }
                    // >
                    //   <span>
                    //     <FormattedMessage
                    //       id="LbLapsedCount"
                    //       defaultMessage="Lapsed Count"
                    //     />
                    //   </span>
                    //   <span className="floatright">
                    //     {this.state.lapsedcount == 0 ? (
                    //       <span className="no-count">0</span>
                    //     ) : (
                    //       <span className="default-count">
                    //         <React.Fragment>
                    //           {this.state.leavetypeid == 3
                    //             ? `${this.state.lapsedcount / 60}:${
                    //                 this.state.lapsedcount % 60
                    //               } Hr`
                    //             : this.state.lapsedcount}
                    //         </React.Fragment>
                    //       </span>
                    //     )}
                    //   </span>
                    // </div>
                    <div
                      className={
                        this.state.lapsedcount == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={this.state.lapsedcount && this.lapsedLeaves}
                    >
                      <span>
                        <FormattedMessage
                          id="LbLapsedCount"
                          defaultMessage="Lapsed Count"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.lapsedcount == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.leavetypeid == 3
                                ? `${this.state.lapsedcount / 60}:${
                                    this.state.lapsedcount % 60
                                  } Hr`
                                : this.state.lapsedcount}
                            </React.Fragment>
                            {this.state.lapsedLeaves ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.lapsedLeaves ? (
                        <div>
                          {!this.state.lapsedleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.lapsedleaves.map((option) => (
                                <Grid key="key" container>
                                  <Grid item xs={12} md={10} sm={4}>
                                    <span className="data-value">
                                      {getFormattedDate(option.lapseddate)}
                                    </span>
                                    {/* <span className="margin-left-8 margin-right-8">
                                        ⟷
                                      </span>
                                      <span className="data-value">
                                        {getFormattedDate(option.todatetime)}
                                      </span> */}
                                  </Grid>

                                  <Grid item xs={12} md={2} sm={2}>
                                    <p className="data-count">
                                      {option.lapseddata}
                                    </p>
                                  </Grid>
                                </Grid>
                              ))}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.encashed ? (
                    <div
                      className={
                        this.state.encashed == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbEncashed"
                          defaultMessage="Encashed"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.encashed == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.encashed}
                            </React.Fragment>
                          </span>
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.giftdebited ? (
                    <div
                      className={
                        this.state.giftdebited == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type "
                      }
                      onClick={this.state.giftdebited && this.showDebitGifted}
                    >
                      <span>Gift debited</span>
                      <span className="floatright">
                        {this.state.giftdebited == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="no-count">
                            <React.Fragment>
                              {this.state.giftdebited}
                            </React.Fragment>
                            {/* {this.state.showDebitGifted ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )} */}
                          </span>
                        )}
                      </span>
                      {this.state.showDebitGifted ? (
                        <div>
                          {!this.state.giftdebitedleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.giftdebitedleaves.map((option) => (
                                <Grid key="key" container>
                                  <Grid item xs={12} md={3} sm={4}>
                                    <p className="t-14">
                                      {getFormattedDate(option.crediteddate)}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={7} sm={4}>
                                    <span className="t-14">
                                      {option.comment}
                                    </span>
                                  </Grid>
                                  <Grid item xs={12} md={2} sm={4}>
                                    <p className="data-count">
                                      {option.crediteddata}
                                    </p>
                                  </Grid>
                                </Grid>
                              ))}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.additionaldebit ? (
                    <div
                      className={
                        this.state.additionaldebit == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={
                        this.state.additionaldebit && this.showAdditionalDebit
                      }
                    >
                      <span>
                        <FormattedMessage
                          id="LbAdditionalDebited"
                          defaultMessage="Additional Debited"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.additionaldebit == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.leavetypeid == 3
                                ? `${parseInt(
                                    this.state.additionaldebit / 60,
                                  )} Hrs ${
                                    this.state.additionaldebit % 60
                                  } Mins`
                                : this.state.additionaldebit}
                            </React.Fragment>
                            {this.state.showAdditionalDebit ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.showAdditionalDebit ? (
                        <div>
                          {!this.state.additionaldebitleaves ? (
                            <span>0</span>
                          ) : (
                            <React.Fragment>
                              {this.state.additionaldebitleaves.map(
                                (option) => (
                                  <Grid
                                    key="key"
                                    container
                                    style={{
                                      borderBottom: "1px dotted #ddd",
                                      paddingBottom: 8,
                                      marginBottom: 8,
                                    }}
                                  >
                                    <Grid item xs={12} md={8} sm={4}>
                                      <p className="data-value">
                                        {getFormattedDate(option.crediteddate)}
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={4}
                                      sm={4}
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        paddingRight: 12,
                                      }}
                                    >
                                      <div>
                                        <p
                                          className="data-count"
                                          style={{
                                            float: "left",
                                            marginRight:
                                              this.state.masterprofileid == 9
                                                ? 4
                                                : 20,
                                          }}
                                        >
                                          {option.crediteddata}
                                        </p>
                                        {this.state.masterprofileid == 9 && (
                                          <img
                                            src={deleteIcon}
                                            onClick={this.deleteAdjustedLeaves.bind(
                                              this,
                                              option.empleaveadjustmentid,
                                            )}
                                            style={{
                                              float: "left",
                                              height: 16,
                                            }}
                                          ></img>
                                        )}
                                      </div>
                                    </Grid>
                                    {option.comment ? (
                                      <Grid item xs={12} md={12} sm={4}>
                                        <p className="data-value">
                                          <strong>Message: </strong>
                                          {option.comment}
                                        </p>
                                      </Grid>
                                    ) : (
                                      ""
                                    )}
                                    {option.addedby ? (
                                      <Grid item xs={12} md={12} sm={4}>
                                        <p className="data-value">
                                          <strong>Debited by: </strong>
                                          {option.addedby}
                                        </p>
                                      </Grid>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                ),
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.usedcompoff ? (
                    <div
                      className={
                        this.state.usedcompoff == 0
                          ? "leave-credit-type-disabled"
                          : "leave-credit-type"
                      }
                      onClick={this.state.usedcompoff && this.usedCompOffLeaves}
                    >
                      <span>
                        <FormattedMessage
                          id="LbUsedCompOff"
                          defaultMessage="Used Compoff"
                        />
                      </span>
                      <span className="floatright">
                        {this.state.usedcompoff == 0 ? (
                          <span className="no-count">0</span>
                        ) : (
                          <span className="default-count">
                            <React.Fragment>
                              {this.state.usedcompoff}
                            </React.Fragment>
                            {this.state.usedCompOffLeaves ? (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_down
                              </i>
                            ) : (
                              <i className="material-icons muiicon expand-icon">
                                keyboard_arrow_right
                              </i>
                            )}
                          </span>
                        )}
                      </span>
                      {this.state.usedCompOffLeaves ? (
                        <div>
                          {!this.state.usedcompoffleaves ? (
                            <span>0</span>
                          ) : (
                            
                            <React.Fragment>

                              {this.state.usedcompoff != 0 && (
                                <Grid key="key" container>
                                  <Grid item xs={2} md={3} sm={2}>
                                    <span style={{ fontSize: "0.9rem"}}><strong>Credited Date</strong></span>
                                  </Grid>
                                
                                  <Grid item xs={2} md={5} sm={2} style={{textAlign: "center"}}>
                                  <span style={{ fontSize: "0.9rem"}}><strong>Balance Used</strong></span>
                                  </Grid>
                                
                                  <Grid item xs={2} md={4} sm={2} style={{textAlign: "center"}}>
                                  <span style={{ fontSize: "0.9rem"}}><strong>Used Date</strong></span>
                                  </Grid>
                                </Grid>
                              )}

                              {sortArrByDate({
                                      arr: this.state.usedcompoffleaves,
                                      datekey: "useddate",
                                    }).map((option) => (

                                <Grid key="key" container>
                                  <Grid item xs={2} md={3} sm={2}>
                                    <span style={{ fontSize: "0.9rem"}}>
                                      {getFormattedDate(option.crediteddate)}
                                    </span>
                                  </Grid>

                                  <Grid item xs={2} md={5} sm={2} style={{textAlign: "center"}}>
                                    <span style={{ fontSize: "0.9rem"}}>
                                      {option.balanceused}
                                    </span>
                                  </Grid>

                                  <Grid item xs={2} md={4} sm={2} style={{textAlign: "center"}}>
                                    <span style={{ fontSize: "0.9rem"}}>
                                      {getFormattedDate(option.useddate)}
                                    </span>
                                  </Grid>
                                </Grid>
                              ))}
                              
                            </React.Fragment>
                            
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.state.leavetypeid != 99 && (
                <div className="leave-total-debit">
                  <span className="margin-left-8">
                    <FormattedMessage
                      id="LbTotalDebit"
                      defaultMessage="Total Debit"
                    />
                  </span>
                  <span className="floatright">
                    {!this.state.totaldebit ? (
                      <span className="default-count">0</span>
                    ) : (
                      <span className="default-count">
                        <React.Fragment>
                          {this.state.leavetypeid == 3
                            ? `${parseInt(this.state.totaldebit / 60)} Hrs ${
                                this.state.totaldebit % 60
                              } Mins`
                            : this.state.totaldebit}
                        </React.Fragment>
                      </span>
                    )}
                  </span>
                </div>
              )}
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}
